import React from 'react';
import { LicenseComponent } from "../screens/settings/LicenseComponent";
import axios from 'axios';
import Fingerprint2 from 'fingerprintjs2';
import { config } from '../../app/config';
import { updateFingerprint, login, userRefresh, preloaderShow, preloaderHide, setView, alert, splashScreenHide, refreshStorage } from "../../actions";
import { connect } from "react-redux";
import '../../styles/security/login.scss';
import TranslationService from "../../app/services/TranslationService";
import {LanguageComponent} from "../LanguageComponent";
import {ActionButton} from "../icymat-design/ActionButton";
import {WavingTriangle} from "../WavingTriangle";


export class Login extends React.Component {

    /**
     * @param props
     */
    constructor(props)
    {
        super(props);

        this.state = {
            license: false
        };
    };

    componentDidMount() {
        let that = this;
        setTimeout(function() {
            let fingerprint = localStorage.getItem('fingerprint');
            if (fingerprint !== null) {
                //it's old fingerprint so we have to recalculate it and remove user from the localstorage
                if (fingerprint.length === 40) {
                    localStorage.removeItem('fingerprint');
                    localStorage.removeItem('email');
                    localStorage.removeItem('device');

                    that.props.login({
                        email: null,
                        identity: null,
                        device: null
                    });

                    that.props.userRefresh({
                        email: null,
                        imid: [],
                        name: null
                    });

                    that.props.setView(null);
                    that.props.alert(TranslationService.trans(that.props.language, 'login.actions.relogin_required'));
                }
            }

            if (localStorage.getItem('fingerprint') === null) {
                Fingerprint2.get(function (components) {
                    var values = components.map(function (component) { return component.value });
                    localStorage.setItem('fingerprint', Fingerprint2.x64hash128(values.join(''), 64));
                })
            }

            if (that.props.identity !== null && that.props.device !== null) {
                that.refreshUser(that.props.email, that.props.identity, that.props.device);
            } else if (that.props.email !== null && that.props.device !== null) {
                that.refreshUser(that.props.email, that.props.identity, that.props.device);
            } else {
                that.loadLanguage();
            }
        }, 1000);

        if (window.location.search !== "" && window.location.search.indexOf('token') >= 0) {
            let token = window.location.search.replace('?token=', '');

            let that = this;
            this.login(token, function() {
                that.props.preloaderShow();

                setTimeout(function () {
                    window.location.href = window.location.origin;
                });
            });
        }
    }

    isIOS = () => {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    }

    loadLanguage = () => {
        TranslationService.loadHolmTranslations(this.props.language);

        this.props.splashScreenHide();
    }

    initializeLogin = (e) => {
        if (this.isIOS()) {
            window.location.href = config.imidServer + 'oauth/app/' + config.imidOAuthId;
            return;
        }

        let that = this;
        this.props.preloaderShow();

        window.open(config.imidServer + 'oauth/app/' + config.imidOAuthId, "IMid OAuth", "width=550,height=500,resizable=no");
        window.addEventListener('message', function(event) {
            if (!event || !event.data || typeof event.data === 'object' || event.data[0] !== '{') {
                return;
            }

            let response = JSON.parse(event.data);

            if (response.token === undefined) {
                that.props.alert(TranslationService.trans(that.props.language, 'login.actions.failed'));
                that.props.preloaderHide();

                return;
            }

            that.login(response.token);
        });
    };

    login = (token, callback = function() {}) => {
        let that = this;

        let data = {
            token: token,
            fingerprint: localStorage.getItem('fingerprint')
        };

        axios.post(config.apiAddress + '/login', data)
            .then(function (response) {
                if (config.env !== 'prod' && !response.data.developer_access) {
                    that.props.alert(TranslationService.trans(that.props.language, 'login.actions.not_allowed'));
                    that.props.preloaderHide();

                    return;
                }

                localStorage.setItem('email', response.data.user);
                localStorage.setItem('device', response.data.device);

                that.props.login({
                    email: localStorage.getItem('email'),
                    identity: localStorage.getItem('identity'),
                    device: localStorage.getItem('device')
                });

                that.refreshUser(response.data.user, response.data.identity, response.data.device);
                that.props.setView('main');
                callback();
            }).catch(function(response) {
                that.props.alert(TranslationService.trans(that.props.language, 'login.actions.failed'));
                that.props.preloaderHide();
            });
    }

    getStyle = (e) => {
        return {
            display: this.props.email === null && this.props.identity === null ? 'block' : 'none'
        }
    };

    refreshUser = (email, identity, device) => {
        this.props.preloaderShow();

        if (localStorage.getItem('identity') !== null) {
            axios.defaults.headers.common = {
                'X-AUTH-IDENTITY': identity,
                'X-AUTH-DEVICE': device,
                'X-AUTH-FINGERPRINT': localStorage.getItem('fingerprint')
            };
        } else {
            axios.defaults.headers.common = {
                'X-AUTH-USER': email,
                'X-AUTH-DEVICE': device,
                'X-AUTH-FINGERPRINT': localStorage.getItem('fingerprint')
            };
        }

        let that = this;
        axios.get(config.apiAddress + '/user')
            .then(function (response) {
                that.props.userRefresh(response.data);
                that.props.preloaderHide();
                that.loadLanguage();

                if (localStorage.getItem('identity') === null) {
                    localStorage.setItem('identity', response.data.identity);
                }

                localStorage.setItem('language', response.data.language);
                that.props.refreshStorage();
            }).catch(function(response) {
                if (response.response.status !== 200) {
                    localStorage.removeItem('email');
                    localStorage.removeItem('identity');
                    localStorage.removeItem('device');
                    that.props.login({
                        email: null,
                        identity: null,
                        device: null
                    });
                }

                that.props.preloaderHide();
                that.loadLanguage();
            });
    };

    render() {
        /* eslint-disable */
        let alphabet = TranslationService.trans(this.props.language, '_alphabet');
        if (alphabet === '_alphabet') {
            alphabet = 'latin';
        }

        return (
            <div id="login" style={this.getStyle()}>
                <div className="language-selector" style={{position: 'absolute', top: '13px', left: '13px'}}>
                    <LanguageComponent />
                </div>

                <div className={"logo new"}>
                    <WavingTriangle size={175} />
                </div>

                <ActionButton
                    color={'imid'}
                    icon={'icymat imid'}
                    text={TranslationService.trans(this.props.language, 'common.security.sign_in_with_imid')}
                    onClick={this.initializeLogin}
                />

                <div className="license imd-text-accent">
                    {TranslationService.trans(this.props.language, 'login.license.text')}
                    <button className="imd-text-accent" onClick={() => {this.setState({license: true})}}>
                        {TranslationService.trans(this.props.language, 'login.license.button')}
                    </button>
                </div>

                <div className="madeby-mateusz-kolasa">
                    made by
                    <a href="https://mateuszkolasa.com" target="_blank">
                        <img src={"images/logo-mateuszkolasa-" + alphabet + ".svg"} alt="Mateusz Kolasa" />
                    </a>
                </div>

                <dialog className={(this.state.license ? 'imd-dialog imd-bg-blur-black imd-opened' : 'imd-dialog imd-bg-transparent-black')}>
                    <div className="imd-dialog-body imd-bg-20-default imd-text-accent">
                        <header>
                            {TranslationService.trans(this.props.language, 'login.license.name')}
                            <span className="imd-icon imd-icon-xmark imd-dialog-close" onClick={() => {this.setState({license: false});}} />
                        </header>

                        <div className="imd-dialog-content">
                            <LicenseComponent textClass="imd-text-accent" />
                        </div>
                    </div>
                </dialog>
            </div>
        );
        /* eslint-enable */
    }
}

const mapStateToProps = (state) => {
    return {
        email: state.login.email,
        identity: state.login.identity,
        device: state.login.device,
        fingerprint: state.login.fingerprint,
        language: TranslationService.getLanguage(state.user)
    }
};

const mapDispatchToProps = { updateFingerprint, login, userRefresh, preloaderShow, preloaderHide, setView, alert, splashScreenHide, refreshStorage };

export const LoginContainer = connect(mapStateToProps, mapDispatchToProps)(Login);
